import queryString from "query-string";

export function parseViewParameters<TParameters>(location: string): TParameters {
	return queryString.parse(location) as unknown as TParameters;
}
